import { Typography } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'

/**
 * Displays the organisation of the user.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {*}
 */
export const ListItemCellUserOrganisation = (classes, props = {}) => {
  const { organisation } = props

  return (
    <Typography
      color={'black'}
      variant={'body2'}
      className={classes.row}
      sx={{ fontWeight: 700 }}
    >
      {organisation?.value?.name || '-'}
    </Typography>
  )
}

export default CellHOC(ListItemCellUserOrganisation)
